import Vue from "vue";
import Vuex from "@store/store";
import {
    baseUrl,
    isSignedIn,
    getHeaders,
    getMultipartHeaders,
} from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

Vue.use(Vuex);

export async function GetModules() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/${Vuex.getters["auth/getState"].vrmSubscriptionKey}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesActivateOrDeactivateModule(
    moduleId,
    userId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/${moduleId}/user/${userId}/activate`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetVRMListAccessByUser(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/user/${userId}/list-access`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMAccess(vrmAccessId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMAccessUserPacks(
    vrmAccessId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/user-packs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMAccessEntityPacks(
    vrmAccessId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/entity-packs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMProfiles() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profiles`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMModuleProfilesAttributes(
    profileId,
    dataSourceIds,
    vrmAccessId
) {
    await isSignedIn();

    const query = queryFilter({ dataSourceIds });
    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/profile/${profileId}/attributs${query}`;

    return axios.get(urlApi, getHeaders());
}
export async function ModulesServicesGetNewVRMModuleProfilesAttributes(
    profileId,
    dataSourceIds
) {
    await isSignedIn();

    const query = queryFilter({ dataSourceIds });
    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}/attributs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVRMTipologys(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/${userId}/tipologys`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateVRMAccess(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdateVRMAccess(vrmAccessId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesCreatesUserPackVRMAccess(
    vrmAccessId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/user-pack`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesCreatesEntityPackVRMAccess(
    vrmAccessId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/entity-pack`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdatesUserPack(userPackId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/user-pack/${userPackId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesTransferUserPackBalanceToEntityPack(
    userPackId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/user-pack/${userPackId}/transfer-entity-pack`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdatesEntityPack(entityPackId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/entity-pack/${entityPackId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetsUsersVRMAccessTipologyForSpecifiedEntity(
    vrmAccessId,
    entityId,
    tableFilters
) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/entity/${entityId}/list-users${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetModulesById(moduleId, userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/${moduleId}/user/${userId}/submodules`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostConfigRMI(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/configrmi`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetModulesList() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/dropdown`;
    const modulesDropdown = {
        data: {
            result: Vuex.getters[
                "backofficeModulesDropdown/getStateModulesDropdown"
            ],
        },
    };

    if (_.isEmpty(modulesDropdown.data.result)) {
        return axios.get(urlApi, getHeaders());
    } else {
        return new Promise((resolve, reject) => {
            resolve(modulesDropdown);
        });
    }
}

//ORÇAMENTO
export async function ModulesServicesGetBrands(entityParentId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/${entityParentId}/brands`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetGovVatDropdown(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/dropdown/gov-vat`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetModuleBusinessCondition(
    moduleId,
    userId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/${moduleId}/user/${userId}/module-businesscondition`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetGaragesDropdown(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/dropdown/garages`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetLabor(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/labor`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetFluids(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/fluids`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetDownloadExcelFluids(
    entityId,
    templateOnly
) {
    await isSignedIn();

    const query = queryFilter({ templateOnly });
    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/download-excel-fluids${query}`;

    return axios.get(urlApi, { ...getHeaders(), responseType: "blob" });
}

export async function ModulesServicesPostUploadExcelFluids(body, entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/upload-excel-fluids`;

    return axios.post(urlApi, body, getMultipartHeaders());
}
export async function ModulesServicesPostConfigQuotation(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/configquotation`;

    return axios.post(urlApi, body, getHeaders());
}

// FAST SERVICES
export async function ModulesServicesGetRapidService(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/entity/${entityId}`;

    return axios.get(urlApi, getHeaders());
}
export async function ModulesServicesGetRapidServiceSchedulingMargin(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/entity/${entityId}/scheduling-margin`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostCreateRapidService(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPostCreateRapidWithIconService(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/with-upload`;

    return axios.post(urlApi, body, getMultipartHeaders());
}

export async function ModulesServicesPostCreateUpdateRapidServiceScheduling(
    entityId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/entity/${entityId}/scheduling-margin`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesDeleteRapidService(entityServiceId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/${entityServiceId}`;

    return axios.delete(urlApi, getHeaders());
}

//EDIT RapidService
export async function ModulesServicesGetRapidServiceItem(entityServiceId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/${entityServiceId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPutRapidServiceItem(
    body,
    entityServiceId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/${entityServiceId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesPutRapidUploadIconServiceItem(
    body,
    entityServiceId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/rapidservice/${entityServiceId}/with-upload`;

    return axios.put(urlApi, body, getMultipartHeaders());
}

export async function GetGenarts() {
    await isSignedIn();

    const urlApi = `${baseUrl}/B2C/genarts`;

    return axios.get(urlApi, getHeaders());
}

export async function GetGenartsCriterias(genartNr) {
    await isSignedIn();

    const urlApi = `${baseUrl}/B2C/genart/${genartNr}/criterias`;

    return axios.get(urlApi, getHeaders());
}

// SCHEDULING
export async function GetSchedulingGaragesByFilters(tableFilters) {
    await isSignedIn();

    const query = queryFilter(tableFilters);
    const urlApi = `${baseUrl}/Module/scheduling/garages${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSchedulingGarageConfiguration(garageId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/garage/${garageId}/config`;

    return axios.get(urlApi, getHeaders());
}

export async function GetEntityConfiguratioForSchedulingPrePaymentPrice(
    entityId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/entity/${entityId}/pre-payment-price`;

    return axios.get(urlApi, getHeaders());
}

export async function UpdateOrCreateEntityConfiguratioForSchedulingPrePaymentPrice(
    entityId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/entity/${entityId}/pre-payment-price`;

    return axios.post(urlApi, body, getHeaders());
}

export async function UpdateSchedulingGarageConfiguration(garageId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/garage/${garageId}/config`;

    return axios.put(urlApi, body, getHeaders());
}

export async function CreateAndUpdateSchedulingGarageConfiguration(
    garageId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/garage/${garageId}/config`;

    return axios.post(urlApi, body, getHeaders());
}

export async function GetSchedulingCalendarServicesExtraEvent(eventId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/event/${eventId}`;

    return axios.get(urlApi, getHeaders());
}

export async function CreateSchedulingCalendarServicesExtraEvent(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/event`;

    return axios.post(urlApi, body, getHeaders());
}

export async function GetSchedulingCalendarServicesExtraAllEvents(
    garageId,
    pagination
) {
    await isSignedIn();

    const query = queryFilter({
        garageId,
        year: pagination.year,
        month: pagination.month,
    });
    const urlApi = `${baseUrl}/Module/scheduling/service-extra/events${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function RemoveSchedulingCalendarServicesExtraEvent(eventId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/event/${eventId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function RemoveSchedulingCalendarServicesExtraDayEvent(
    dayEventId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/day-event/${dayEventId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function UpdateSchedulingCalendarServicesExtraEvent(
    eventId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/event/${eventId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function UpdateSchedulingCalendarServicesExtraDayEvent(
    dayEventId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/service-extra/day-event/${dayEventId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function GetSchedulingCalendarEvents(garageId, pagination) {
    await isSignedIn();

    const query = queryFilter({
        garageId,
        year: pagination.year,
        month: pagination.month,
    });
    const urlApi = `${baseUrl}/Module/scheduling/calendar/events${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSchedulingCalendarServicesExtra(garageId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/garage/${garageId}/calendar/services-extra`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSchedulingServicesExtra(garageId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/garage/${garageId}/services-extra`;

    return axios.get(urlApi, getHeaders());
}

export async function CreateSchedulingCalendarEvent(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/calendar/event`;

    return axios.post(urlApi, body, getHeaders());
}

export async function RemoveSchedulingCalendarEvent(eventId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/calendar/event/${eventId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function RemoveSchedulingCalendarById(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/calendar`;

    return axios.delete(urlApi, {
        data: {
            calendarDate: body.calendarDate,
            calendarEventId: body.calendarEventId,
        },
        headers: getHeaders().headers,
    });
}

export async function UpdateSchedulingCalendarEvent(eventId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/calendar/event/${eventId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function UpdateSchedulingCalendarIndividualEvent(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/scheduling/calendar`;

    return axios.put(urlApi, body, getHeaders());
}

export async function GetCredentialsWebshopByUser(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/webshop/${userId}/credentials`;

    return axios.get(urlApi, getHeaders());
}

export async function PostCredentialsWebshopByUser(userId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/webshop/${userId}/credentials`;

    return axios.post(urlApi, body, getHeaders());
}

export async function GetSILiAmbCredentialByUser(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${userId}/credential`;

    return axios.get(urlApi, getHeaders());
}

export async function PostSILiAmbCredentialByUser(userId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${userId}/credential`;

    return axios.post(urlApi, body, getHeaders());
}

export async function GetSILiAmbRoutes(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${entityId}/list-routes`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSILiAmbEntities(routerId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${routerId}/list-entities`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSILiAmbProfiles(routerId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/profiles`;

    return axios.get(urlApi, getHeaders());
}

export async function GetSILiAmbEntity(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${entityId}/entities`;

    return axios.get(urlApi, getHeaders());
}

export async function DeleteAssociateEntityRoutes(entityRouterId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/entityroute/${entityRouterId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function AssociateEntityToRouter(routerId, entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${routerId}/entity/${entityId}/associate`;

    return axios.post(urlApi, "", getHeaders());
}

export async function NewRouterSIliAmb(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${entityId}/router`;

    return axios.post(urlApi, body, getHeaders());
}

export async function PostSILiAmbTransporter(userId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/${userId}/transporter`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetUserGarageConfig(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/user/${userId}/garage/config`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateAndUpdateUserGarageConfig(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/user/garage/config`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesCreatePlanningOperation(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/operation-type`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdatePlanningOperation(
    planningOperationTypeId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/operation-type/${planningOperationTypeId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesDeletePlanningOperation(
    planningOperationTypeId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/operation-type/${planningOperationTypeId}`;

    return axios.delete(urlApi, {
        data: { isDelete: true },
        headers: getHeaders().headers,
    });
}

export async function ModulesServicesGetPlanningOperation(body) {
    await isSignedIn();

    const query = queryFilter(body);
    const urlApi = `${baseUrl}/Module/planning/operation-types${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetAccessVrmIndicators(vrmAccessId, body) {
    await isSignedIn();

    const query = queryFilter(body);
    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/indicators${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetModulesEndDate(moduleId, userId) {
    await isSignedIn();

    const query = queryFilter({ moduleId, userId });
    const urlApi = `${baseUrl}/Module/end-date${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostModuleEndDate(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/end-date`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesConfigSMCredentials(userId) {
    await isSignedIn();

    const query = queryFilter({ userId });
    const urlApi = `${baseUrl}/Module/supplier-management/module-config${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function GetIndicadoresByUserId(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/mygarage/user/${userId}/indicators`;

    return axios.get(urlApi, getHeaders());
}

export async function PostIndicadoresByUserId(userId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/mygarage/user/${userId}`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetUsersPlanningModule(filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/planning/users${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetPreFilled(userId, vrmAccessId) {
    await isSignedIn();

    let query = "";
    if (userId) {
        query = queryFilter({ userId });
    } else if (vrmAccessId) {
        query = queryFilter({ vrmAccessId });
    }
    const urlApi = `${baseUrl}/Module/vehicle/pre-filled${query}`;
    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesDeletePlanningUser(planningUserId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/planning/user/${planningUserId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesGetSubModulesRMI(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/configrmi/user/${userId}/submodules`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesExportPack(userPackId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/user-pack/${userPackId}/export`;

    return axios.get(urlApi, { ...getHeaders(), responseType: "blob" });
}

export async function ModulesServicesHistoryEntityPacks(entityPackId, filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/vehicle/entity-pack/${entityPackId}/history${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesCreateEntityPack(
    entityId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/entity/${entityId}/pack`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesTecDocServicesGetEntityPacks(
    entityId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/tecdocservice/entity/${entityId}/packs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesUpdateEntityPack(
    entityPackId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/entity/pack/${entityPackId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesTecDocServicesCreateUserPack(
    userId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/user/${userId}/pack`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesTecDocServicesGetUserPacks(
    userId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/tecdocservice/user/${userId}/packs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesUpdateUserPack(
    userPackId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/user/pack/${userPackId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesTecDocServicesGetPacksTotalizers(userId) {
    await isSignedIn();

    const query = queryFilter({ userId });
    const urlApi = `${baseUrl}/Module/tecdocservice/packs-totalizer${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesIndicators(
    editUserId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/tecdocservice/user/${editUserId}/indicators${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesDropdownUsers(editUserId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/user/${editUserId}/dropdown-users`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesIndicatorsDropdowns(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/user/${userId}/indicators/dropdowns`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTecDocServicesGetAccessYearList(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/tecdocservice/user/${userId}/dropdown-years`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesTransferPackBalanceToEntityPack(
    userPackId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/user-pack/${userPackId}/transfer-entity-pack`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesBudgetSettingsListItemMpIds(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/dropdown/itemmpids`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsListEntityEcoValues(
    entityId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/ecovalues${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsEcoValueLoadDefaultValues(
    entityId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/ecovalue/load-default-values`;

    return axios.put(urlApi, {}, getHeaders());
}

export async function ModulesServicesBudgetSettingsCreateEntityEcoValue(
    entityId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/entity/${entityId}/ecovalue`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesBudgetSettingsDeleteEcoValue(
    entityEcoValueId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/ecovalue/${entityEcoValueId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsUpdateEcoValue(
    body,
    entityEcoValueId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/ecovalue/${entityEcoValueId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesBudgetSettingsFavoriteBrandsDropdown(
    userId,
    filters = {}
) {
    await isSignedIn();

    let filteredObj = { ...filters };
    ["data", "backup"].forEach((prop) => {
        delete filteredObj[prop];
    });

    filteredObj.userId = userId;
    const query = queryFilter(filteredObj);
    const urlApi = `${baseUrl}/Module/quotation/favorite-brands/dropdown/brands${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsProductsFamiliesDropdown(
    userId,
    filters = {}
) {
    await isSignedIn();

    let filteredObj = { ...filters };
    ["data", "backup"].forEach((prop) => {
        delete filteredObj[prop];
    });

    filteredObj.userId = userId;
    const query = queryFilter(filteredObj);
    const urlApi = `${baseUrl}/Module/quotation/favorite-brands/dropdown/genarts${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsFavoriteBrandsOrdering(
    entityId
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/quotation/favorite-brands/ordering${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesBudgetSettingsFavoriteBrandsData(userId) {
    await isSignedIn();

    const query = queryFilter({ userId });
    const urlApi = `${baseUrl}/Module/quotation/favorite-brands${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVehicleDataSourceAttrs() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/attributs`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesUpdateVehicleDataSourceAttrs(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/attributs`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetVehicleProfilesDrop() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profiles`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetAllVehicleAttrsById(profileId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}/all-attributs`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVehicleAttrsById(
    profileId,
    dataSourceIds
) {
    await isSignedIn();

    const query = queryFilter(dataSourceIds);
    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}/attributs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesUpdateVehicleAttrsById(profileId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}/attributs`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetUserErpCredentials(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/erp/user/${userId}/credentials`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateAndUpdateUserErpCredentials(
    userId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/erp/user/${userId}`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesDeleteActiveReceptionCards(
    activeReceptionEntityCardId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/activereception/card/${activeReceptionEntityCardId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesGetActiveReceptionDefaultItemMpIds() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/activereception/dropdown/default-itemmpids`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetActiveReceptionOperationCards(params) {
    await isSignedIn();

    const query = queryFilter(params);
    const urlApi = `${baseUrl}/Module/activereception/dropdown/operations${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateOrUpdateActiveReceptionCard(
    entityId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/activereception/entity/${entityId}/card`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetActiveReceptionCards(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/activereception/entity/${entityId}/cards`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetActiveReceptionDefaultCardIcons() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/activereception/dropdown/default-card-icons`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateProfile(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profile`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesDeleteProfile(profileId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesUpdateProfile(profileId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/profile/${profileId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetSTREMAConfigurations(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/strema/${userId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesSetSTREMAConfigurations(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/strema/${entityId}`;

    return axios.put(urlApi, body, getMultipartHeaders());
}

export async function ModulesServicesChatGetUserConversationList(
    userId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/chat/users/${userId}/conversations${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesChatGetUserList(
    userId,
    filterOut,
    groupConversation
) {
    await isSignedIn();

    const query = queryFilter({ filterOut, groupConversation });
    const urlApi = `${baseUrl}/Module/chat/users/${userId}${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesChatCreateConversation(userId, body) {
    await isSignedIn();

    const query = queryFilter({ userId });
    const urlApi = `${baseUrl}/Module/chat/conversations${query}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesChatDeleteConversation(conversationId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/chat/conversations/${conversationId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesChatRemoveUserFromConversation(
    conversationId,
    userId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/chat/conversations/${conversationId}/participants/${userId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesChatAddUserToConversation(
    conversationId,
    userId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/chat/conversations/${conversationId}/participants/${userId}`;

    return axios.put(urlApi, {}, getHeaders());
}

export async function ModulesServicesGetGovVat() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/govvat`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostGovVat(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/govvat/`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetDSBConfigurations(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/dsb/${userId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesSetDSBConfigurations(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/dsb/${entityId}`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetDetailsForSpecifiedVehicleAccessId(
    vrmAccessId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetAutoComConfigurations(entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/autocom/entity/${entityId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetVehicleAccessIndicatorDropdowns(
    vrmAccessId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vehicle/access/${vrmAccessId}/indicators/dropdowns`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesGetDetailsForSpecifiedVinoeId(
    vrmAccessId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vinoe/access/${vrmAccessId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesSetAutoComConfigurations(entityId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/autocom/entity/${entityId}`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesGetVinoePreFilled(userId) {
    await isSignedIn();

    const query = queryFilter({ userId });
    const urlApi = `${baseUrl}/Module/vinoe/pre-filled${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostVinoeAccess(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vinoe/access`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPutVinoeAccessById(vrmAccessId, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/vinoe/access/${vrmAccessId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineGetDistributionList(filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/promo-engine/groups${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetMatrixList(entityId) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/matrix${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetGroupsEntities(
    entityId,
    promoEngineGroupId = ""
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    let urlApi = `${baseUrl}/Module/promo-engine/group/entities${query}`;
    if (promoEngineGroupId) {
        urlApi = `${baseUrl}/Module/promo-engine/group/${promoEngineGroupId}/entities${query}`;
    }

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetEntities(filters) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/promo-engine/entities${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetCampaignTypes(entityId) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/campaign-types${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineCreateOrUpdateCampaignType(
    campaignTypeId,
    entityId,
    body
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    let urlApi = `${baseUrl}/Module/promo-engine/campaign-type${query}`;
    if (campaignTypeId) {
        urlApi = `${baseUrl}/Module/promo-engine/campaign-type/${campaignTypeId}`;
        return axios.put(urlApi, body, getHeaders());
    }

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineDeleteCampaignType(
    campaignTypeId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/promo-engine/campaign-type/${campaignTypeId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetReceivers(entityId) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/receiver-types${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineCreateOrUpdateReceiver(
    receiverTypeId,
    entityId,
    body
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/receiver-type${query}`;
    if (receiverTypeId) {
        urlApi = `${baseUrl}/Module/promo-engine/receiver-type/${receiverTypeId}`;
        return axios.put(urlApi, body, getHeaders());
    }

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineDeleteReceiver(receiverTypeId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/promo-engine/receiver-type/${receiverTypeId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesPromoEnginePostMatrixList(entityId, body) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/matrix${query}`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineGetReceiverTypesDropdown(
    entityId
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/receiver-type/dropdown${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEngineGetCampaignTypesDropdown(
    entityId
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/campaign-type/dropdown${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPromoEnginePostReceiverTypes(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/promo-engine/entities-receiver-types`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineCreateOrUpdateGroup(
    groupId,
    entityId,
    body
) {
    await isSignedIn();

    const query = queryFilter({ entityId });
    const urlApi = `${baseUrl}/Module/promo-engine/group${query}`;
    if (groupId) {
        urlApi = `${baseUrl}/Module/promo-engine/group/${groupId}`;
        return axios.put(urlApi, body, getHeaders());
    }

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesPromoEngineDeleteGroup(groupId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/promo-engine/group/${groupId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesGetStremaEntityPacksList(
    entityId,
    filters
) {
    await isSignedIn();

    const query = queryFilter(filters);
    const urlApi = `${baseUrl}/Module/strema/${entityId}/entity-packs${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesCreateStremaEntityPack(body, entityId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/strema/entity/${entityId}/entity-pack`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdateStremaEntityPack(
    body,
    stremaEntityPackId
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/strema/entity-pack/${stremaEntityPackId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesUpdatesTheQuotationLabors(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/quotation/labors`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesgetSiliambConteinerTypes() {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/container-types`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesUpdateSiliambConteinerType(
    containerId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/container-types/${containerId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesCreateSiliambConteinerType(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/container-types`;

    return axios.post(urlApi, body, getHeaders());
}

export async function ModulesServicesDeleteSiliambConteinerType(containerId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/siliamb/container-types/${containerId}`;

    return axios.delete(urlApi, getHeaders());
}

export async function ModulesServicesGetRequestManagerConfiguration(userId) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/request-manager/configurations/${userId}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostRequestManagerConfiguration(
    userId,
    body
) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Module/request-manager/configurations/${userId}`;

    return axios.put(urlApi, body, getHeaders());
}

export async function ModulesServicesGetTecDocConfig(userId) {
    await isSignedIn();

    const query = queryFilter({userId})
    const urlApi = `${baseUrl}/BackOffice/tecdocservice/config${query}`;

    return axios.get(urlApi, getHeaders());
}

export async function ModulesServicesPostTecDocConfig(userId, body) {
    await isSignedIn();

    const query = queryFilter({userId});
    const urlApi = `${baseUrl}/BackOffice/tecdocservice/config${query}`;

    return axios.post(urlApi, body, getHeaders());
}
